import { useState } from 'react';

import { FetchClient, FetchClientExecutor } from '@vp/fetch-client';
import { useCustomLogger } from '@vp/pdp-ubik-logging';

export const useFetchClient = (): FetchClient => {
  const { logger } = useCustomLogger();
  const [fetchClient] = useState<FetchClient>(() => {
    FetchClientExecutor.initializeWithLogger({
      debug: logger.debug,
      error: logger.error,
      info: logger.info,
      warn: logger.warn,
      log: logger.log,
    });
    return FetchClientExecutor.client;
  });

  return fetchClient;
};
